'use client'

/**
 * Thin product-level wrapper around design-studio's `<InPageNav>`. Owns only
 * the section list — phase / active-section logic + glass styling all live in
 * design-studio (`<InPageNav>` + `useStickyPhase` + `useActiveSection`).
 */

import { InPageNav } from 'design-studio'

export const MAIN_PAGE_NAV_SECTIONS = [
  { id: 'steps', title: 'How to start' },
  { id: 'features', title: 'Features' },
  { id: 'capabilities', title: 'Capabilities' },
  { id: 'pricing', title: 'Pricing' },
  // { id: 'about', title: 'About' },
  { id: 'applications-detail', title: 'Applications' },
  { id: 'interfaces', title: 'Interfaces' },
  { id: 'codelogician', title: 'CodeLogician' },
] as const

export function MainPageNav() {
  return <InPageNav sections={MAIN_PAGE_NAV_SECTIONS} topPillLabel="Top" />
}
